import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { geoOrthographic, geoGraticule, geoPath, json } from 'd3';
import { feature } from 'topojson-client';

import uiState from './state/uiState';
import worldData from '../assets/world-110m.json';

@observer
class GlobeView extends Component {
  worldData = [];
  constructor() {
    super();
  }

  componentDidMount() {
    this.worldData = [feature(worldData, worldData.objects.land)];
  }

  render() {
    const projection = geoOrthographic()
      .scale(49)
      .translate([50, 50])
      .rotate([-this.props.center[0], -this.props.center[1]]);

    // console.log(this.props.center)

    return (
      <div>
        <svg
          style={{ display: 'block' }}
          width={'100%'}
          height={'100%'}
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid meet"
        >
          <g className="countries">
            {this.worldData.map((d, i) => (
              <path
                key={`path-${i}`}
                d={geoPath().projection(projection)(d)}
                className="country"
                fill={`#FFFFFF`}
                stroke="none"
              />
            ))}
          </g>
          <g className="grati">
            {geoGraticule()
              .lines()
              .map((d, i) => (
                <path
                  key={`grati-${i}`}
                  d={geoPath().projection(projection)(d)}
                  className="graticule"
                  stroke="#FFFFFF"
                  strokeWidth={0.5}
                  fill="none"
                />
              ))}
          </g>
          <g className="svg-sun" transform="translate(50,50)">
            <line
              x1="-5"
              x2="5"
              y1="-5"
              y2="5"
              style={{ stroke: '#000', strokeWidth: 6 }}
            />
            <line
              x1="5"
              x2="-5"
              y1="-5"
              y2="5"
              style={{ stroke: '#000', strokeWidth: 6 }}
            />
            <line
              x1="-5"
              x2="5"
              y1="-5"
              y2="5"
              style={{ stroke: '#FFF', strokeWidth: 2 }}
            />
            <line
              x1="5"
              x2="-5"
              y1="-5"
              y2="5"
              style={{ stroke: '#FFF', strokeWidth: 2 }}
            />
          </g>
        </svg>
      </div>
    );
  }
}

export default GlobeView;
